import { setQueryParam } from './query-params';
import { key } from 'ionicons/icons';
import { FieldFilterDto } from '../api/APIClient';

export interface IStateService{

  _reviver?: (...args: any[]) => any;
  state: any;

}

const getCurrentPath = (): string => {
  return window.location.pathname;
}

export const fieldFilterToUrlParam = (filter: FieldFilterDto) => {
  return `${filter.fieldId},${filter.type},${filter.values.join(',')}`;
}

export const fieldFilterFromUrlParam = (param: string): FieldFilterDto => {

  const [fieldId, type, ...values] = param.split(',');

  return new FieldFilterDto({
    fieldId,
    type: +type,
    values
  })
}

export class LocalStorageStateService implements IStateService {

  _reviver = (key, value) => {
    if ('string' === typeof value && /^\d{4}-[01]\d-[0-3]\dT[012]\d(?::[0-6]\d){2}\.\d{3}Z$/.test(value)) {
      var date = new Date(value);
      if (+date === +date) {
        return date;
      }
    }
    return value;
  }

  set state(value: any) {
      localStorage.setItem(getCurrentPath(), JSON.stringify(value));
  }

  get state() {
      return JSON.parse(localStorage.getItem(getCurrentPath()), this._reviver);
  }
}

export class SessionStorageStateService implements IStateService {

  _reviver = (key, value) => {
    if ('string' === typeof value && /^\d{4}-[01]\d-[0-3]\dT[012]\d(?::[0-6]\d){2}\.\d{3}Z$/.test(value)) {
      var date = new Date(value);
      if (+date === +date) {
        return date;
      }
    }
    return value;
  }

  set state(value: any) {
    sessionStorage.setItem(getCurrentPath(), JSON.stringify(value));
  }

  get state() {
    return JSON.parse(sessionStorage.getItem(getCurrentPath()), this._reviver);
  }
}

export class QueryParamStateService implements IStateService {

  _reviver = (value) => {

    //Revive Dates
    if ('string' === typeof value && /^\d{4}-[01]\d-[0-3]\dT[012]\d(?::[0-6]\d){2}\.\d{3}Z$/.test(value)) {
      var date = new Date(value);
      if (+date === +date) {
        return date;
      }

      //Revive Integers
    } else if ('string' === typeof value && /^[0-9]+$/.test(value)) {
      return +value;
    }
    return value;
  }

  get state() {

    const params = new URLSearchParams(window.location.search);

    let state = {};

    params.forEach((value, key) => {

      if (key.indexOf('[]') !== -1) {
        key = key.replace('[]', '');

        if (key === 'fieldFilters') {
          state[key] = state[key] ? [...state[key], fieldFilterFromUrlParam(value)] : [fieldFilterFromUrlParam(value)];
        } else {
          state[key] = state[key] ? [...state[key], this._reviver(value)] : [this._reviver(value)];
        }

      } else {
        state[key] = this._reviver(value);
      }

    });

    return state;
  }

  set state(state: {[key: string]: any}) {
    const searchParams = new URLSearchParams(window.location.search);
    Object.entries(state).forEach(([key, value]) => {
      if (value === undefined || value === null) {
        searchParams.delete(key)
        return;
      }
      if (value instanceof Date) {
        searchParams.set(key, value.toISOString());
      } else if(Array.isArray(value)) {

        if (searchParams.has(`${key}[]`)) {
          searchParams.delete(`${key}[]`);
        }

        value.forEach((v) => {

          if (key === 'fieldFilters') {
            searchParams.append(`${key}[]`, fieldFilterToUrlParam(v as FieldFilterDto))
          } else {
            searchParams.append(`${key}[]`, v.toString());
          }

        })
      }
      else {
        searchParams.set(key, value.toString());
      }
    })

    history.replaceState(null, null, `${window.location.pathname}?${searchParams.toString()}`);
  }
}




const SessionStateStore = new SessionStorageStateService();
const QueryParamStateStore = new QueryParamStateService();

export const StateStore: IStateService = QueryParamStateStore;



